export default __webpack_public_path__ + "static/media/usc-films-ios.dff7f8b4.jpg";